export type PregnancyOutcome =
  | "miscarriage"
  | "live_birth"
  | "still_birth"
  | "abortion";

export type DeliveryType = "natural" | "c_section";

export const PREGNANCY_OUTCOME_OPTIONS: {
  labelKey: string;
  value: PregnancyOutcome;
}[] = [
  {
    labelKey: "med_history.gynae.pregnancies.outcome.live_birth",
    value: "live_birth",
  },
  {
    labelKey: "med_history.gynae.pregnancies.outcome.miscarriage",
    value: "miscarriage",
  },
  {
    labelKey: "med_history.gynae.pregnancies.outcome.still_birth",
    value: "still_birth",
  },
  {
    labelKey: "med_history.gynae.pregnancies.outcome.abortion",
    value: "abortion",
  },
];

export const DELIVERY_TYPE_OPTIONS: {
  labelKey: string;
  value: DeliveryType;
}[] = [
  {
    labelKey: "med_history.gynae.pregnancies.delivery_type.natural",
    value: "natural",
  },
  {
    labelKey: "med_history.gynae.pregnancies.delivery_type.c_section",
    value: "c_section",
  },
];

export function outcomeHasDeliveryDetails(
  outcome: PregnancyOutcome | null | undefined,
): boolean {
  return outcome === "live_birth" || outcome === "still_birth";
}
